import { Component } from '@angular/core';
import { CmsNavigationComponent } from '@spartacus/core';
import { CmsComponentData, NavigationComponent } from '@spartacus/storefront';
import { UigNavigationService } from 'src/app/services/uig-navigation.service';

@Component({
    selector: 'app-uig-navigation',
    templateUrl: './uig-navigation.component.html',
    styleUrls: ['./uig-navigation.component.scss'],
    standalone: false
})
export class UigNavigationComponent extends NavigationComponent {

  constructor(
    protected componentData: CmsComponentData<CmsNavigationComponent>,
    protected service: UigNavigationService
  ) {
    super(componentData,service);
  }

}
